import { combineReducers } from 'redux';

function filterCount(f: any): Number {
  const filter = Object.assign({}, f);
  delete filter.count;
  delete filter.active;
  let count = 0;
  for (let prop in filter) {
    const fil = filter[prop];
    if (Array.isArray(fil)) {
      count += fil.length;
    } else if (fil) {
      count += 1;
    }
  }
  return count;
}

function activeFilterCount(f: any): Number {
  const filter = Object.assign({}, f);
  delete filter.count;
  delete filter.active;
  let active = 0;

  for (let prop in filter) {
    const fil = filter[prop];

    if (Array.isArray(fil)) {
      // eslint-disable-next-line
      fil.forEach((item: any) => {
        active += item && item.applied ? 1 : 0;
      });
    } else {
      active += fil && fil.applied ? 1 : 0;
    }
  }
  return active;
}

const filter = (state = { count: 0, active: 0 }, action: any) => {
  switch (action.type) {
    case 'ADD_FILTER_TAG':
      let filter = { ...state, ...action.filter };
      delete filter.modified;
      filter.count = filterCount(filter);
      filter.active = activeFilterCount(filter);
      return filter;
    case 'RESET_FILTER_TAG':
      return { count: 0, active: 0 };
    case 'REPLACE_FILTER_TAG':
      let nFilter = { ...action.newFilter };
      nFilter.count = filterCount(nFilter);
      nFilter.active = activeFilterCount(nFilter);
      delete nFilter.modified;
      return nFilter;
    case 'APPLY_FILTER_TAG':
      let aFilter: any = { ...state };
      delete aFilter.count;
      delete aFilter.active;
      delete aFilter.modified;
      for (let prop in aFilter) {
        const fil = aFilter[prop];
        if (Array.isArray(fil)) {
          for (let a = 0; a < fil.length; a++) {
            fil[a].applied = true;
          }
        } else {
          fil.applied = true;
        }
      }
      aFilter.count = filterCount(aFilter);
      aFilter.active = filterCount(aFilter);
      return aFilter;
    case 'GET_FILTER_TAG':
    case 'ACTIVE_APPLY_BUTTON_FILTER_TAGS':
      let f: any = { ...state };
      f.active = false;
      f.modified = true;
      return f;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  filter,
});
